<template>
  <div id="app" :class="themeClass">
    <complex-sizing v-if="['ridley','eddy merckx'].includes(brand.toLowerCase())" :bike-type="bikeType" :lang="lang" :use-size="useSizeEvent" />
    <simple-sizing v-else :data="JSON.parse(data)" />
  </div>
</template>

<script>
import i18n from "./i18n";
import ComplexSizing from './complexSizing.vue';
import SimpleSizing from './simpleSizing.vue';

export default {
  i18n,
  name: "sizingWidget",
  components: {
    ComplexSizing,
    SimpleSizing
  },
  props: {
    theme: {
      type: String,
      default: null,
    },
    brand: {
      type: String,
      default: "Ridley",
    },
    bikeType: {
      type: String,
      default: "",
    },
    lang: {
      type: String,
      default: "en",
    },
    useSizeEvent: {
      type: Boolean,
      default: true,
    },
    data: {
      type: String,
      default: null
    }
  },
  data() {
    return {
    };
  },
  mounted() {
    if (this.$i18n) {
        this.$i18n.locale = this.lang; // || 'en'; // default language for development purposes
    }
    this.showBikeSelect = !this.bikeType;
    console.log('this.data', this.data, JSON.parse(this.data));
  },
  methods: {
  },
  computed: {
    themeClass() {
      return `theme--${this.theme ? this.theme : this.brand.toLowerCase().replace(' ', '-')}`
    }
  },
};
</script>
<style lang="scss">
</style>
